module.exports = __webpack_public_path__ + "media/images/icons/hotel-3b686444184f68f449f115ad7ae9f919.png";